import React, { useState, useCallback, useEffect, useRef } from "react";
import Card from "../../../../../../common/element/Card";
import Table from "../../../../../../common/element/Table";
import Tag from "../../../../../../common/element/Tag";
import { useParams, Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GetAllSpecificProviderWorkerInd } from "../../../../../../actions/admin-provider/SpecificProviderWorkerInduction";
import Scrollbar from "../../../../../../common/element/ScrollBar";
const Inductions = () => {
  const { Tr, Th, Td, THead, TBody } = Table;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [workerIndData, setWorkerIndData] = useState([]);
  const { SpecificProviderData } = useSelector((state) => state);

  const FetchAllSpecificProviderWorkerInd = useCallback(() => {
    // setIsFetching(true);
    if(SpecificProviderData?.organisation_id){

      const payload = {
        provider_org_id: SpecificProviderData?.organisation_id,
      };
  
      dispatch(GetAllSpecificProviderWorkerInd(payload,SpecificProviderData?.organisation_id))
        .then((res) => {
          if (res?.success === true) {
            const arrayData = res?.data;
            setWorkerIndData(arrayData);
  
            // Handle the arrayData as needed
          } else {
            // Optionally handle the failure case
            console.error("Failed to fetch data");
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [dispatch]);

  useEffect(() => {
    
    FetchAllSpecificProviderWorkerInd();
  }, []);

  return (
    <Card className="py-6 border border-gray-200 rounded-xl dark-shadow">
      <div className="px-6">
        <div className="card-header flex border-b border-gray-200 pb-5 items-center mb-5">
          <span className="mr-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M12 21L11.8999 20.8499C11.2053 19.808 10.858 19.287 10.3991 18.9098C9.99286 18.5759 9.52476 18.3254 9.02161 18.1726C8.45325 18 7.82711 18 6.57482 18H5.2C4.07989 18 3.51984 18 3.09202 17.782C2.71569 17.5903 2.40973 17.2843 2.21799 16.908C2 16.4802 2 15.9201 2 14.8V6.2C2 5.07989 2 4.51984 2.21799 4.09202C2.40973 3.71569 2.71569 3.40973 3.09202 3.21799C3.51984 3 4.07989 3 5.2 3H5.6C7.84021 3 8.96031 3 9.81596 3.43597C10.5686 3.81947 11.1805 4.43139 11.564 5.18404C12 6.03968 12 7.15979 12 9.4M12 21V9.4M12 21L12.1001 20.8499C12.7947 19.808 13.142 19.287 13.6009 18.9098C14.0071 18.5759 14.4752 18.3254 14.9784 18.1726C15.5467 18 16.1729 18 17.4252 18H18.8C19.9201 18 20.4802 18 20.908 17.782C21.2843 17.5903 21.5903 17.2843 21.782 16.908C22 16.4802 22 15.9201 22 14.8V6.2C22 5.07989 22 4.51984 21.782 4.09202C21.5903 3.71569 21.2843 3.40973 20.908 3.21799C20.4802 3 19.9201 3 18.8 3H18.4C16.1598 3 15.0397 3 14.184 3.43597C13.4314 3.81947 12.8195 4.43139 12.436 5.18404C12 6.03968 12 7.15979 12 9.4"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <div className="flex flex-col">
            <span className="text-gray-900 text-base font-semibold">
              Inductions
            </span>
            <p className="text-gray-600">Pending completion</p>
          </div>
        </div>
      </div>
      <div className="max-h-[345px] overflow-y-auto cstm-scrollbar">
        <div>
          <div className="px-6">
            <div className="overflow-hidden border rounded-lg border-gray-200">
              <Table>
                <TBody>
                  {workerIndData &&
                    workerIndData.length >0 &&
                    workerIndData.map((item, index) => (
                      <Tr
                        className="cursor-pointer"
                        key={index}
                        onClick={() => navigate("/provider/workers")}
                      >
                        <Td>{`${item?.assignWorker?.worker_individual?.first_name} ${item?.assignWorker?.worker_individual?.last_name}`}</Td>
                        <Td>
                          {item?.clientAssign?.clientCompInd?.[0]?.company_ind_name }{" "}
                          <span className="block text-gray-600">
                            {item?.trading_name}{" "}
                            {/* You may replace client_org_id with actual client name if you have that information */}
                          </span>
                        </Td>
                        <Td className="w-28">
                          <Tag
                            className={
                              item.completion_status === "Complete"
                                ? "bg-gray-100 text-gray-700"
                                : item.completion_status ===
                                  "Awaiting action"
                                  ? "bg-blue-50 text-blue-800"
                                  : "bg-gray-100 text-gray-700"
                            }
                          >
                          
                            {item?.completion_status?item?.completion_status:"Pending"}
                          </Tag>
                        </Td>
                      </Tr>
                    ))}
                  {workerIndData.length===0 &&(
                        <Tr  >
                            <Td  className="text-center p-4">No data available</Td>
                        </Tr>)}
                </TBody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};
export default Inductions;
